const TIME_RE_COMPUTED = 1000 * 60; // 1minute

export { 
    TIME_RE_COMPUTED
}